import Phaser from 'phaser'
import $ from "jquery";
import MainScene from './MainScene'

const externalHost = `https://xelestech.com/`



export default class LoadingScene extends Phaser.Scene {



  constructor ()

  {

    super({ key: 'LoadingScene' });

  }

  preload() {

 // this.load.image('bg', 'assets/bg2.jpg');
 this.load.image('bg_complete', `${externalHost}assets/island/island_filled.jpg`)
 var empty_image = this.load.image('empty_image', `${externalHost}assets/box_invi.png`);

 this.load.html('bubbleChatHtml', `${externalHost}assets/text/bubbleChat.html`);
 this.load.html('nameHtml', `${externalHost}assets/text/name.html`);
 // //loading of all buildings
 this.load.image('building1',`${externalHost}assets/buildings/building_1.png`)
 this.load.json('building1_shapes', `${externalHost}assets/buildings/building_collision.json`);
 this.load.image('building2',`${externalHost}assets/buildings/building_2.png`);
 this.load.json('building2_shapes', `${externalHost}assets/buildings/building_collision.json`);
 this.load.image('building3',`${externalHost}assets/buildings/building_3.png`);
 this.load.json('building3_shapes', `${externalHost}assets/buildings/building_collision.json`);
 this.load.image('building4',`${externalHost}assets/buildings/building_4.png`);
 this.load.json('building4_shapes', `${externalHost}assets/buildings/building_collision.json`);
 this.load.image('building5', `${externalHost}assets/buildings/building_5.png`);
 this.load.json('building5_shapes', `${externalHost}assets/buildings/building_collision.json`);
 this.load.image('building6', `${externalHost}assets/buildings/building_6.png`);
 this.load.json('building6_shapes', `${externalHost}assets/buildings/building_collision.json`);
 this.load.image('building7', `${externalHost}assets/buildings/building_7.png`);
 this.load.json('building7_shapes', `${externalHost}assets/buildings/building_collision.json`);
 this.load.image('building8', `${externalHost}assets/buildings/building_8.png`);
 this.load.json('building8_shapes', `${externalHost}assets/buildings/building_collision.json`);

 // //loading of island collision shapes
 this.load.json('island_shapes', `${externalHost}assets/island/island_collision.json`);
 this.load.image('island_5',`${externalHost}assets/island/island_2.png`)
 this.load.image('island5',`${externalHost}assets/island/island5.png`)
 this.load.image('island6',`${externalHost}assets/island/island6.png`)
 this.load.image('shadow1',`${externalHost}assets/island/shadow1-min.png`)
 this.load.image('shadow2',`${externalHost}assets/island/shadow2-min.png`)



 //loading of props
 this.load.json('props1_shapes', `${externalHost}assets/props/props_collision.json`);
 //this.load.image('bush2',`${externalHost}assets/props/_0000_bush_2.png`)
 //this.load.image('bush1',`${externalHost}assets/props/_0001_bush_1.png`)
 //this.load.image('leaf1',`${externalHost}assets/props/_0002_leaf_1.png`)
 this.load.image('tree1',`${externalHost}assets/props/_0003_tree_1.png`)
 this.load.image('tree2',`${externalHost}assets/props/_0004_tree_2.png`)
 //this.load.image('carrot1',`${externalHost}assets/props/_0005_carrot_1.png`)
 //this.load.image('carrot2',`${externalHost}assets/props/_0006_carrot_2.png`)
 //this.load.image('leaf2',`${externalHost}assets/props/_0007_leaf_2.png`)
 //this.load.image('leaf3',`${externalHost}assets/props/_0008_leaf_3.png`)
 //this.load.image('leaf4',`${externalHost}assets/props/_0009_leaf_4.png`)
 this.load.image('leaf5',`${externalHost}assets/props/_0010_leaf_5.png`)
 //this.load.image('leaf6',`${externalHost}assets/props/_0011_leaf_6.png`)
 //this.load.image('leaf7',`${externalHost}assets/props/_0012_leaf_7.png`)
 //this.load.image('leaf8',`${externalHost}assets/props/_0013_leaf_8.png`)
 //this.load.image('leaf9',`${externalHost}assets/props/_0014_leaf_9.png`)
 //this.load.image('leaf11',`${externalHost}assets/props/_0015_leaf_11.png`)
 //this.load.image('leaf10',`${externalHost}assets/props/_0016_leaf_10.png`)
 //this.load.image('leaf12',`${externalHost}assets/props/_0017_leaf_12.png`)
 //this.load.image('leaf13',`${externalHost}assets/props/_0018_leaf_13.png`)
 this.load.image('rockwall1',`${externalHost}assets/props/_0019_rockwall_1.png`)
 this.load.image('rockwall2',`${externalHost}assets/props/_0020_rockwall_2.png`)
 this.load.image('postbox',`${externalHost}assets/props/_0021_postbox.png`)
 this.load.image('lamppost',`${externalHost}assets/props/_0022_lamppost.png`)
 this.load.image('fence1',`${externalHost}assets/props/_0023_fence_1.png`)
 this.load.image('fence2',`${externalHost}assets/props/_0024_fence_2.png`)
 this.load.image('box1',`${externalHost}assets/props/_0025_box_1.png`)
 this.load.image('box2',`${externalHost}assets/props/_0026_box_2.png`)
 this.load.image('box3',`${externalHost}assets/props/_0027_box_3.png`)
 this.load.image('box4',`${externalHost}assets/props/_0028_box_4.png`)
 //this.load.image('whitecarrot',`${externalHost}assets/props/_0029_whitecarrot.png`)
 //this.load.image('pinkcarrot',`${externalHost}assets/props/_0030_pinkcarrot.png`)
 this.load.image('mushroom1',`${externalHost}assets/props/_0031_mushroom_1.png`)
 this.load.image('mushroom2',`${externalHost}assets/props/_0032_mushroom_2.png`)
 //this.load.image('grass1',`${externalHost}assets/props/_0033_grass_1.png`)
 //this.load.image('grass2',`${externalHost}assets/props/_0034_grass_2.png`)
 //this.load.image('grass3',`${externalHost}assets/props/_0035_grass_3.png`)
 //this.load.image('grass4',`${externalHost}assets/props/_0036_grass_4.png`)
 //this.load.image('grass5',`${externalHost}assets/props/_0037_grass_5.png`)
 //this.load.image('grass6',`${externalHost}assets/props/_0038_grass_6.png`)
 //this.load.image('grass7',`${externalHost}assets/props/_0039_grass_7.png`)
 this.load.image('rock1',`${externalHost}assets/props/_0040_rock_1.png`)
 this.load.image('rock2',`${externalHost}assets/props/_0041_rock_2.png`)
 this.load.image('rock3',`${externalHost}assets/props/_0042_rock_3.png`)
 this.load.image('rock4',`${externalHost}assets/props/_0043_rock_4.png`)
 this.load.image('rock5',`${externalHost}assets/props/_0044_rock_5.png`)
 this.load.image('sand1',`${externalHost}assets/props/_0045_sand_1.png`)
 this.load.image('sand2',`${externalHost}assets/props/_0046_sand_2.png`)
 this.load.image('rockpath1',`${externalHost}assets/props/_0047_rockpath_1.png`)
 this.load.image('rockpath2',`${externalHost}assets/props/_0048_rockpath_2.png`)
 this.load.image('rock6',`${externalHost}assets/props/_0049_rock_6.png`)
 this.load.image('rock7',`${externalHost}assets/props/_0050_rock_7.png`)
 this.load.image('rock8',`${externalHost}assets/props/_0051_rock_8.png`)
 this.load.image('rock9',`${externalHost}assets/props/_0052_rock_9.png`)
 this.load.image('rock10',`${externalHost}assets/props/_0053_rock_10.png`)
 this.load.image('chair1',`${externalHost}assets/props/_0054_chair_1.png`)
 this.load.image('chair2',`${externalHost}assets/props/_0055_chair_2.png`)
 this.load.image('barrel',`${externalHost}assets/props/_0056_barrel.png`)
 this.load.image('sandpath',`${externalHost}assets/props/_0057_sandpath.png`)
 this.load.image('fence3',`${externalHost}assets/props/_0058_fence_3.png`)
 this.load.image('stall1',`${externalHost}assets/props/_0059_stall_1.png`)
 this.load.image('stall2',`${externalHost}assets/props/_0060_stall_2.png`)
 this.load.image('log',`${externalHost}assets/props/_0061_log.png`)
 //this.load.image('whiteflower',`${externalHost}assets/props/_0062_whiteflower.png`)
 //this.load.image('blueflower',`${externalHost}assets/props/_0063_blueflower.png`)
 //this.load.image('yellowflower',`${externalHost}assets/props/_0064_yellowflower.png`)
 this.load.image('yellowflowerpot',`${externalHost}assets/props/_0065_yellowflowerpot.png`)
 this.load.image('redflowerpot',`${externalHost}assets/props/_0066_redflowerpot.png`)
 this.load.image('whiteflowerbush',`${externalHost}assets/props/_0067_whiteflowerbush.png`)
 this.load.image('redflowerbush',`${externalHost}assets/props/_0068_redflowerbush.png`)
 this.load.image('rockcircle',`${externalHost}assets/props/_0069_rockcircle.png`)
 //this.load.image('fountain',`${externalHost}assets/props/_0070_fountain.png`)
 //this.load.image('egg',`${externalHost}assets/props/_0071_egg.png`)
 this.load.image('purplehouse_1',`${externalHost}assets/props/_0072_purplehouse_1.png`)
 this.load.image('purplehouse_2',`${externalHost}assets/props/_0073_purplehouse_2.png`)
 this.load.image('redhouse_1',`${externalHost}assets/props/_0074_redhouse_1.png`)
 this.load.image('redhouse_2',`${externalHost}assets/props/_0075_redhouse_2.png`)
 this.load.image('bluehouse_1',`${externalHost}assets/props/_0076_bluehouse_1.png`)
 this.load.image('bluehouse_2',`${externalHost}assets/props/_0077_bluehouse_2.png`)
 this.load.image('pumpkin',`${externalHost}assets/props/_0078_pumpkin.png`)
 this.load.image('rock11',`${externalHost}assets/props/_0079_rock_11.png`)
 this.load.image('rock12',`${externalHost}assets/props/_0080_rock_12.png`)
 this.load.image('rock13',`${externalHost}assets/props/_0081_rock_13.png`)
 this.load.image('log2',`${externalHost}assets/props/_0082_log_2.png`)


 this.load.image('chief',`${externalHost}assets/npc/Chief.png`)

 this.load.spine('leaf1',`${externalHost}assets/animations/Props/_0002_leaf_1.json`,`${externalHost}assets/animations/Props/_0002_leaf_1.atlas`)
 this.load.spine('carrot1',`${externalHost}assets/animations/Props/_0005_carrot_1.json`,`${externalHost}assets/animations/Props/_0005_carrot_1.atlas`)
 this.load.spine('carrot2',`${externalHost}assets/animations/Props/_0006_carrot_2.json`,`${externalHost}assets/animations/Props/_0006_carrot_2.atlas`)
 this.load.spine('leaf2',`${externalHost}assets/animations/Props/_0007_leaf_2.json`,`${externalHost}assets/animations/Props/_0007_leaf_2.atlas`)
 this.load.spine('leaf3',`${externalHost}assets/animations/Props/_0008_leaf_3.json`,`${externalHost}assets/animations/Props/_0008_leaf_3.atlas`)
 this.load.spine('leaf4',`${externalHost}assets/animations/Props/_0009_leaf_4.json`,`${externalHost}assets/animations/Props/_0009_leaf_4.atlas`)
 this.load.spine('leaf6',`${externalHost}assets/animations/Props/_0011_leaf_6.json`,`${externalHost}assets/animations/Props/_0011_leaf_6.atlas`)
 this.load.spine('leaf7',`${externalHost}assets/animations/Props/_0012_leaf_7.json`,`${externalHost}assets/animations/Props/_0012_leaf_7.atlas`)
 this.load.spine('leaf8',`${externalHost}assets/animations/Props/_0013_leaf_8.json`,`${externalHost}assets/animations/Props/_0013_leaf_8.atlas`)
 this.load.spine('leaf9',`${externalHost}assets/animations/Props/_0014_leaf_9.json`,`${externalHost}assets/animations/Props/_0014_leaf_9.atlas`)
 this.load.spine('leaf11',`${externalHost}assets/animations/Props/_0015_leaf_11.json`,`${externalHost}assets/animations/Props/_0015_leaf_11.atlas`)
 this.load.spine('leaf10',`${externalHost}assets/animations/Props/_0016_leaf_10.json`,`${externalHost}assets/animations/Props/_0016_leaf_10.atlas`)
 this.load.spine('leaf12',`${externalHost}assets/animations/Props/_0017_leaf_12.json`,`${externalHost}assets/animations/Props/_0017_leaf_12.atlas`)
 this.load.spine('leaf13',`${externalHost}assets/animations/Props/_0018_leaf_13.json`,`${externalHost}assets/animations/Props/_0018_leaf_13.atlas`)
 this.load.spine('whitecarrot',`${externalHost}assets/animations/Props/_0029_whitecarrot.json`,`${externalHost}assets/animations/Props/_0029_whitecarrot.atlas`)
 this.load.spine('pinkcarrot',`${externalHost}assets/animations/Props/_0030_pinkcarrot.json`,`${externalHost}assets/animations/Props/_0030_pinkcarrot.atlas`)
 this.load.spine('grass1',`${externalHost}assets/animations/Props/_0033_grass_1.json`,`${externalHost}assets/animations/Props/_0033_grass_1.atlas`)
 this.load.spine('grass2',`${externalHost}assets/animations/Props/_0034_grass_2.json`,`${externalHost}assets/animations/Props/_0034_grass_2.atlas`)
 this.load.spine('grass3',`${externalHost}assets/animations/Props/_0035_grass_3.json`,`${externalHost}assets/animations/Props/_0035_grass_3.atlas`)
 this.load.spine('grass4',`${externalHost}assets/animations/Props/_0036_grass_4.json`,`${externalHost}assets/animations/Props/_0036_grass_4.atlas`)
 this.load.spine('grass5',`${externalHost}assets/animations/Props/_0037_grass_5.json`,`${externalHost}assets/animations/Props/_0037_grass_5.atlas`)
 this.load.spine('grass6',`${externalHost}assets/animations/Props/_0038_grass_6.json`,`${externalHost}assets/animations/Props/_0038_grass_6.atlas`)
 this.load.spine('grass7',`${externalHost}assets/animations/Props/_0039_grass_7.json`,`${externalHost}assets/animations/Props/_0039_grass_7.atlas`)
 this.load.spine('whiteflower',`${externalHost}assets/animations/Props/_0062_whiteflower.json`,`${externalHost}assets/animations/Props/_0062_whiteflower.atlas`)
 this.load.spine('blueflower',`${externalHost}assets/animations/Props/_0063_blueflower.json`,`${externalHost}assets/animations/Props/_0063_blueflower.atlas`)
 this.load.spine('yellowflower',`${externalHost}assets/animations/Props/_0064_yellowflower.json`,`${externalHost}assets/animations/Props/_0064_yellowflower.atlas`)
 this.load.spine('egg',`${externalHost}assets/animations/Props/_0071_egg.json`,`${externalHost}assets/animations/Props/_0071_egg.atlas`)

 this.load.spritesheet('x_icon',`${externalHost}assets/animations/x_icon.png`,{ frameWidth: 104, frameHeight: 104 ,startFrame:0, endFrame: 21})

this.load.spritesheet('bush2',`${externalHost}assets/animations/props_sprite/0000_Bush_2_349_X236-min.png`,{ frameWidth: 349, frameHeight: 236 })
this.load.spritesheet('bush1',`${externalHost}assets/animations/props_sprite/0001_Bush_1_336_X_237-min.png`,{ frameWidth: 336, frameHeight: 237 })
this.load.spritesheet('leaf1',`${externalHost}assets/animations/props_sprite/0002_leaf_1_935_X_652-min.png`,{ frameWidth: 935, frameHeight: 652 })
this.load.spritesheet('carrot1',`${externalHost}assets/animations/props_sprite/0005_Carrot_1_639_X_723-min.png`,{ frameWidth: 639, frameHeight: 723 ,startFrame:0, endFrame: 25})
this.load.spritesheet('carrot2',`${externalHost}assets/animations/props_sprite/0006_Carrot_2_413_X_468-min.png`,{ frameWidth: 413, frameHeight: 468 })
this.load.spritesheet('leaf2',`${externalHost}assets/animations/props_sprite/0007_Leaf_2_664_X_620_1-min.png`,{ frameWidth: 664, frameHeight: 620 })
this.load.spritesheet('leaf3',`${externalHost}assets/animations/props_sprite/0008_Leaf_3_689_X_474-min.png`,{ frameWidth: 689, frameHeight: 474 })
this.load.spritesheet('leaf4',`${externalHost}assets/animations/props_sprite/0009_Leaf_4_482_X_543-min.png`,{ frameWidth: 482, frameHeight: 543 })
this.load.spritesheet('leaf6',`${externalHost}assets/animations/props_sprite/0011_Leaf_6_354_X_347-min.png`,{ frameWidth: 354, frameHeight: 347,startFrame:0, endFrame: 39 })
this.load.spritesheet('leaf7',`${externalHost}assets/animations/props_sprite/0012_Leaf_7_497_X_375-min.png`,{ frameWidth: 497, frameHeight: 375 })
this.load.spritesheet('leaf8',`${externalHost}assets/animations/props_sprite/0013_Leaf_8_308_X_383-min.png`,{ frameWidth: 308, frameHeight: 383 })
this.load.spritesheet('leaf9',`${externalHost}assets/animations/props_sprite/0014_Leaf_9_502_X_369-min.png`,{ frameWidth: 502, frameHeight: 369 })
this.load.spritesheet('leaf11',`${externalHost}assets/animations/props_sprite/0015_Leaf_11_482_X_394-min.png`,{ frameWidth: 482, frameHeight: 394 })
this.load.spritesheet('leaf10',`${externalHost}assets/animations/props_sprite/0016_Leaf_10_433_X_359-min.png`,{ frameWidth: 433, frameHeight: 359,startFrame:0, endFrame: 39 })
this.load.spritesheet('leaf12',`${externalHost}assets/animations/props_sprite/0017_Leaf_12_565_X_439-min.png`,{ frameWidth: 565, frameHeight: 439 })
this.load.spritesheet('leaf13',`${externalHost}assets/animations/props_sprite/0018_Leaf_13_459_X_482-min.png`,{ frameWidth: 459, frameHeight: 482 })
this.load.spritesheet('whitecarrot',`${externalHost}assets/animations/props_sprite/0029_WhiteCarrot_747_X_853-min.png`,{ frameWidth: 747, frameHeight: 853,startFrame:0, endFrame: 33  })
this.load.spritesheet('pinkcarrot',`${externalHost}assets/animations/props_sprite/0030_PinkCarrot_641_X_808-min.png`,{ frameWidth: 641, frameHeight: 808 ,startFrame:0, endFrame: 19})
this.load.spritesheet('grass1',`${externalHost}assets/animations/props_sprite/0033_Grass_1_214_X_195-min.png`,{ frameWidth: 214, frameHeight: 195 ,startFrame:0, endFrame: 39})
this.load.spritesheet('grass2',`${externalHost}assets/animations/props_sprite/0034_Grass_2_192_X_131-min.png`,{ frameWidth: 192, frameHeight: 131 ,startFrame:0, endFrame: 39})
this.load.spritesheet('grass3',`${externalHost}assets/animations/props_sprite/0035_Grass_3_204_X_122-min.png`,{ frameWidth: 204, frameHeight: 122 ,startFrame:0, endFrame: 39})
this.load.spritesheet('grass4',`${externalHost}assets/animations/props_sprite/0036_Grass_4_260_X_167-min.png`,{ frameWidth: 260, frameHeight: 167 ,startFrame:0, endFrame: 39})
this.load.spritesheet('grass5',`${externalHost}assets/animations/props_sprite/0037_Grass_5_251_X_251-min.png`,{ frameWidth: 251, frameHeight: 251 ,startFrame:0, endFrame: 39})
this.load.spritesheet('grass6',`${externalHost}assets/animations/props_sprite/0038_Grass_6_116_X_78-min.png`,{ frameWidth: 116, frameHeight: 78 ,startFrame:0, endFrame: 39})
this.load.spritesheet('grass7',`${externalHost}assets/animations/props_sprite/0039_Grass_7_212_X_165-min.png`,{ frameWidth: 212, frameHeight: 165 ,startFrame:0, endFrame: 39})
this.load.spritesheet('whiteflower',`${externalHost}assets/animations/props_sprite/0062_Whiteflower_99_X_158-min.png`,{ frameWidth: 99, frameHeight: 158 })
this.load.spritesheet('blueflower',`${externalHost}assets/animations/props_sprite/0063_Blueflower_99_X_158-min.png`,{ frameWidth: 75, frameHeight: 98 })
this.load.spritesheet('yellowflower',`${externalHost}assets/animations/props_sprite/0064_Yellowflower_95_X_107-min.png`,{ frameWidth: 95, frameHeight: 107 })
this.load.spritesheet('fountain',`${externalHost}assets/animations/props_sprite/0070_fountain_719_X_692-min.png`,{ frameWidth: 719, frameHeight: 692,startFrame:0, endFrame: 5 })
this.load.spritesheet('egg',`${externalHost}assets/animations/props_sprite/0071_Egg_337_X_233-min.png`,{ frameWidth: 337, frameHeight: 233,startFrame:0, endFrame: 13 })



 this.load.spine('chief',`${externalHost}assets/npc/Chief.json`,`${externalHost}assets/npc/Chief.atlas`)
 this.load.spine('farmer',`${externalHost}assets/npc/Farmer.json`,`${externalHost}assets/npc/Farmer.atlas`)
 this.load.spine('knight',`${externalHost}assets/Knight1.json`,`${externalHost}assets/Knight1.atlas`)


 this.load.spine('boy', `${externalHost}assets/animations/spineFox4/Fox4.json`, `${externalHost}assets/animations/spineFox4/Fox4.atlas`);

 this.load.spritesheet("frames", `${externalHost}assets/npcChatBox1.png`, {
    frameWidth: 1000,
    frameHeight: 1000
  });
 this.load.audio('bgMusic', [`${externalHost}assets/music/bg_music.mp3`]);
 this.load.image("retroFont", `${externalHost}assets/retroFont.png`);
 this.load.bitmapFont("atari", `${externalHost}assets/font/gem.png`, `${externalHost}assets/font/gem.xml`);
 this.load.bitmapFont("onChanga", `${externalHost}assets/font/onChanga.png`, `${externalHost}assets/font/onChanga.xml`);
 this.load.bitmapFont("Moulpali", `${externalHost}assets/font/Moulpali.png`, `${externalHost}assets/font/Moulpali.xml`);
 this.loadAvatars()
 let loadingElement = `<div id="loader" class="loading-wrapper">
 <img class="loading-logo" src="${externalHost}assets/TalesOfSoulofox.png">
  <div>Loading...</div>
 <div class="loading" id="loading-status"></div>
</div>  `
$('body').append(loadingElement);
    // var progressBar = this.add.graphics();

    // var progressBox = this.add.graphics();



    // var width = this.cameras.main.width;

    // var height = this.cameras.main.height;



    // let progressBarX = (width/2) - 150;

    // let progressBarY = (height/2) - 200

    // progressBox.fillStyle(0x222222, 0.8);

    // progressBox.fillRect(progressBarX ,progressBarY , 320, 50);



    // var loadingText = this.make.text({

    //     x: width / 2,

    //     y: height / 2 - 50,

    //     text: 'Loading...',

    //     style: {

    //         font: '20px monospace',

    //         fill: '#ffffff'

    //     }

    // });

    // loadingText.setOrigin(0.5, 0.5);

    

    // var percentText = this.make.text({

    //     x: width / 2,

    //     y: height / 2 - 5,

    //     text: '0%',

    //     style: {

    //         font: '18px monospace',

    //         fill: '#ffffff'

    //     }

    // });

    // percentText.setOrigin(0.5, 0.5);

    

    // var assetText = this.make.text({

    //     x: width / 2,

    //     y: height / 2 + 50,

    //     text: '',

    //     style: {

    //         font: '18px monospace',

    //         fill: '#ffffff'

    //     }

    // });

    // assetText.setOrigin(0.5, 0.5);

    

    this.load.on('progress', function (value) {
        let progressValue = parseInt(value * 100);
  
        document.getElementById("loading-status").textContent = progressValue +"%"
        // percentText.setText(parseInt(value * 100) + '%');

        // progressBar.clear();

        // progressBar.fillStyle(0xffffff, 1);

        // progressBar.fillRect(progressBarX,progressBarY +10, 300 * value, 30);

    });

    

    this.load.on('fileprogress', function (file) {

        //assetText.setText('Loading asset: ' + file.key);

    });

    let that = this;

    this.load.on('complete', function () {
      let params = {
        "userName": "arunbluez",
        "walletAddress": "4rTBgwFRdAr5Eci2s7ekMDXNBirBkzp3BymLBszZahVY",
        "emailAddress": "arunbluez@gmail.com",
        "nftMetaData": {
            "rank": 431,
            "localJson": "https://storage.googleapis.com/soulofox-prod.appspot.com/output/37.json",
            "status": "Minted",
            "txid": "3xYyHEzVzqMi9C2oR1SiGiR7Wj8R31VziG5nf22tBdyP9GUaVHXa2dBGNFy8QmeGNbJJkSW5jvLEtMGAHi8W6DvZ",
            "dna": "5-9-5-0-1-0-9-0-0-2",
            "arLink": "https://arweave.net/9xIetvVnuaIlt6-sJ3LTTzk9wFyvdSzuknkDis60Bzc",
            "attributesList": {
                "Background": "Forbidding Tundra West",
                "Right Hand": "Japanese Lantern",
                "Back Weapon": "Wooden Guitar",
                "Face Accessories": "Wooden Glasses",
                "Apparel": "Rifleman Outfit",
                "Fur": "Pink Fur Black Ear",
                "Eyes": "Aqua"
            },
            "localImage": "https://storage.googleapis.com/soulofox-prod.appspot.com/output/37.png",
            "name": "Foxian Gen0 #38",
            "attributes": [
                {
                    "value": "Forbidding Tundra West",
                    "trait_type": "Background"
                },
                {
                    "trait_type": "Back Weapon",
                    "value": "Wooden Guitar"
                },
                {
                    "value": "Pink Fur Black Ear",
                    "trait_type": "Fur"
                },
                {
                    "value": "Aqua",
                    "trait_type": "Eyes"
                },
                {
                    "trait_type": "Apparel",
                    "value": "Rifleman Outfit"
                },
                {
                    "trait_type": "Face Accessories",
                    "value": "Wooden Glasses"
                },
                {
                    "value": "Japanese Lantern",
                    "trait_type": "Right Hand"
                }
            ],
            "attributesNumber": 7,
            "description": "Soulofox NFT #38 is a Uniquely Generated & collectible Foxian with evolving community driven Lore, built on Solana",
            "date": {
                "seconds": 1633760362,
                "nanoseconds": 691000000
            },
            "rankLevel": "champion",
            "mintKey": "JCejCykMJV9MnNNmujXgEJHwUPf1p1fHzwQ9XxyTeHFW",
            "number": 38,
            "score": {
                "id": 38,
                "value": 174.79
            }
        },
        "ffItems": [
            {
                "name": "Small Purple Mushroom #V01-071",
                "symbol": "SFFV1",
                "dna": "V01-071",
                "description": "As Dahlys dream within the dream emporium, exciting and fantastic worlds come into their purview. Have your Foxian explore the world of Soulofox with a Dahlys item equipped for the adventures!",
                "seller_fee_basis_points": 800,
                "image": "https://arweave.net/TgUjIFrr0gd52b9d9ZD_0rmzyHPMTLG2jeWolIK0-rs?ext=png",
                "attributes": [
                    {
                        "trait_type": "Slot",
                        "value": "Left Hand"
                    },
                    {
                        "trait_type": "Type",
                        "value": "Cosmetic"
                    },
                    {
                        "trait_type": "Set",
                        "value": "Dahlys"
                    },
                    {
                        "trait_type": "Item Rarity",
                        "value": "Common"
                    }
                ],
                "external_url": "http://app.soulofox.com",
                "collection": {
                    "name": "Foxian & Friends",
                    "family": "Soulofox NFTs"
                },
                "properties": {
                    "category": "image",
                    "files": [
                        {
                            "uri": "https://arweave.net/TgUjIFrr0gd52b9d9ZD_0rmzyHPMTLG2jeWolIK0-rs?ext=png",
                            "type": "image/png"
                        }
                    ],
                    "creators": [
                        {
                            "address": "4BnjJ6bpQf8kETbUHSTC4jFmzi2RNWP719zHXzJQWRAX",
                            "share": 60
                        },
                        {
                            "address": "GnVBMXkb2cbYoRygKt2FFxrE2w4VnBrRPVLCrCSF8dRE",
                            "share": 15
                        },
                        {
                            "address": "8VAHrpJ9nsqRLaujbzpuCxhAhjsE8wA4ZvUHwx2VZw3y",
                            "share": 15
                        },
                        {
                            "address": "8zmgbz9pB5iHvf7Pzm6J84Af3HTBnAAABAVrpKh6aKtq",
                            "share": 10
                        }
                    ]
                }
            },
            {
                "name": "Demon Bat Wings #V01-107",
                "symbol": "SFFV1",
                "dna": "V01-107",
                "description": "Furnish your Foxian with weapons of legend, arcane artifacts containing great power, armour forged from the bones of an ancient race of dragons, and more—from the world of Guild Saga.",
                "seller_fee_basis_points": 800,
                "image": "https://arweave.net/7J1aoHTSv-N1fgEcQtGeUEkBgP4uIaSkxdu0zl3iZQY?ext=png",
                "attributes": [
                    {
                        "trait_type": "Slot",
                        "value": "Back Weapon"
                    },
                    {
                        "trait_type": "Type",
                        "value": "Cosmetic"
                    },
                    {
                        "trait_type": "Set",
                        "value": "Guild Saga"
                    },
                    {
                        "trait_type": "Item Rarity",
                        "value": "Rare"
                    }
                ],
                "external_url": "http://app.soulofox.com",
                "collection": {
                    "name": "Foxian & Friends",
                    "family": "Soulofox NFTs"
                },
                "properties": {
                    "category": "image",
                    "files": [
                        {
                            "uri": "https://arweave.net/7J1aoHTSv-N1fgEcQtGeUEkBgP4uIaSkxdu0zl3iZQY?ext=png",
                            "type": "image/png"
                        }
                    ],
                    "creators": [
                        {
                            "address": "4BnjJ6bpQf8kETbUHSTC4jFmzi2RNWP719zHXzJQWRAX",
                            "share": 60
                        },
                        {
                            "address": "GnVBMXkb2cbYoRygKt2FFxrE2w4VnBrRPVLCrCSF8dRE",
                            "share": 15
                        },
                        {
                            "address": "8VAHrpJ9nsqRLaujbzpuCxhAhjsE8wA4ZvUHwx2VZw3y",
                            "share": 15
                        },
                        {
                            "address": "8zmgbz9pB5iHvf7Pzm6J84Af3HTBnAAABAVrpKh6aKtq",
                            "share": 10
                        }
                    ]
                }
            },
            {
                "name": "Gold Demon Mask #V01-158",
                "symbol": "SFFV1",
                "dna": "V01-158",
                "description": "Furnish your Foxian with weapons of legend, arcane artifacts containing great power, armour forged from the bones of an ancient race of dragons, and more—from the world of Guild Saga.",
                "seller_fee_basis_points": 800,
                "image": "https://arweave.net/g77Oj2iq2iQr1ZhamxB7kqwGXbxcM_eGtn5od8uR5RA?ext=png",
                "attributes": [
                    {
                        "trait_type": "Slot",
                        "value": "Face Accessories"
                    },
                    {
                        "trait_type": "Type",
                        "value": "Cosmetic"
                    },
                    {
                        "trait_type": "Set",
                        "value": "Guild Saga"
                    },
                    {
                        "trait_type": "Item Rarity",
                        "value": "Common"
                    }
                ],
                "external_url": "http://app.soulofox.com",
                "collection": {
                    "name": "Foxian & Friends",
                    "family": "Soulofox NFTs"
                },
                "properties": {
                    "category": "image",
                    "files": [
                        {
                            "uri": "https://arweave.net/g77Oj2iq2iQr1ZhamxB7kqwGXbxcM_eGtn5od8uR5RA?ext=png",
                            "type": "image/png"
                        }
                    ],
                    "creators": [
                        {
                            "address": "4BnjJ6bpQf8kETbUHSTC4jFmzi2RNWP719zHXzJQWRAX",
                            "share": 60
                        },
                        {
                            "address": "GnVBMXkb2cbYoRygKt2FFxrE2w4VnBrRPVLCrCSF8dRE",
                            "share": 15
                        },
                        {
                            "address": "8VAHrpJ9nsqRLaujbzpuCxhAhjsE8wA4ZvUHwx2VZw3y",
                            "share": 15
                        },
                        {
                            "address": "8zmgbz9pB5iHvf7Pzm6J84Af3HTBnAAABAVrpKh6aKtq",
                            "share": 10
                        }
                    ]
                }
            },
            {
                "name": "Spotted Green Shroom #V01-057",
                "symbol": "SFFV1",
                "dna": "V01-057",
                "description": "As Dahlys dream within the dream emporium, exciting and fantastic worlds come into their purview. Have your Foxian explore the world of Soulofox with a Dahlys item equipped for the adventures!",
                "seller_fee_basis_points": 800,
                "image": "https://arweave.net/q4mn7Bzz6dMul4XTjx-MZj-5HGQhg5FzOQeY0MLsyi8?ext=png",
                "attributes": [
                    {
                        "trait_type": "Slot",
                        "value": "Hat"
                    },
                    {
                        "trait_type": "Type",
                        "value": "Cosmetic"
                    },
                    {
                        "trait_type": "Set",
                        "value": "Dahlys"
                    },
                    {
                        "trait_type": "Item Rarity",
                        "value": "Common"
                    }
                ],
                "external_url": "http://app.soulofox.com",
                "collection": {
                    "name": "Foxian & Friends",
                    "family": "Soulofox NFTs"
                },
                "properties": {
                    "category": "image",
                    "files": [
                        {
                            "uri": "https://arweave.net/q4mn7Bzz6dMul4XTjx-MZj-5HGQhg5FzOQeY0MLsyi8?ext=png",
                            "type": "image/png"
                        }
                    ],
                    "creators": [
                        {
                            "address": "4BnjJ6bpQf8kETbUHSTC4jFmzi2RNWP719zHXzJQWRAX",
                            "share": 60
                        },
                        {
                            "address": "GnVBMXkb2cbYoRygKt2FFxrE2w4VnBrRPVLCrCSF8dRE",
                            "share": 15
                        },
                        {
                            "address": "8VAHrpJ9nsqRLaujbzpuCxhAhjsE8wA4ZvUHwx2VZw3y",
                            "share": 15
                        },
                        {
                            "address": "8zmgbz9pB5iHvf7Pzm6J84Af3HTBnAAABAVrpKh6aKtq",
                            "share": 10
                        }
                    ]
                }
            },
            {
                "name": "Blue Book #V01-090",
                "symbol": "SFFV1",
                "dna": "V01-090",
                "description": "As Dahlys dream within the dream emporium, exciting and fantastic worlds come into their purview. Have your Foxian explore the world of Soulofox with a Dahlys item equipped for the adventures!",
                "seller_fee_basis_points": 800,
                "image": "https://arweave.net/XJLIW9RdGMHMts8vuAjNh7-7Gbm_Gzo_NBe79Lyi8hk?ext=png",
                "attributes": [
                    {
                        "trait_type": "Slot",
                        "value": "Right Hand"
                    },
                    {
                        "trait_type": "Type",
                        "value": "Cosmetic"
                    },
                    {
                        "trait_type": "Set",
                        "value": "Dahlys"
                    },
                    {
                        "trait_type": "Item Rarity",
                        "value": "Common"
                    }
                ],
                "external_url": "http://app.soulofox.com",
                "collection": {
                    "name": "Foxian & Friends",
                    "family": "Soulofox NFTs"
                },
                "properties": {
                    "category": "image",
                    "files": [
                        {
                            "uri": "https://arweave.net/XJLIW9RdGMHMts8vuAjNh7-7Gbm_Gzo_NBe79Lyi8hk?ext=png",
                            "type": "image/png"
                        }
                    ],
                    "creators": [
                        {
                            "address": "4BnjJ6bpQf8kETbUHSTC4jFmzi2RNWP719zHXzJQWRAX",
                            "share": 60
                        },
                        {
                            "address": "GnVBMXkb2cbYoRygKt2FFxrE2w4VnBrRPVLCrCSF8dRE",
                            "share": 15
                        },
                        {
                            "address": "8VAHrpJ9nsqRLaujbzpuCxhAhjsE8wA4ZvUHwx2VZw3y",
                            "share": 15
                        },
                        {
                            "address": "8zmgbz9pB5iHvf7Pzm6J84Af3HTBnAAABAVrpKh6aKtq",
                            "share": 10
                        }
                    ]
                }
            }
        ]
      }
        
      
      const message = {
          event_id: 'soulofoxTownhubFinishLoaded',
          isFinishLoaded: true,
      };
    
      window.parent.postMessage(message, '*');
    //   $("#loader").fadeOut("slow");
    //   setTimeout(() => {
    //     that.scene.start('MainScene',params);
    //   }, 1000);
      
    window.addEventListener('message', function(event) {

      if(event.data.event_id === 'soulofoxTownhubIframeId'){
          if (event.data.data.userName) {
     
           
          $("#loader").fadeOut("slow");
          setTimeout(() => {
            that.scene.start('MainScene',event.data.data);

          }, 1000);
            
          console.log(event.data.data);
          }
  
      }
  })
      // progressBar.destroy();

      // progressBox.destroy();

      // loadingText.destroy();

      // percentText.destroy();

      // assetText.destroy();



  });

  }



  create() {

    

    

  }
  loadAvatars() {
    this.load.spritesheet("TwiggyAvatar", `${externalHost}assets/twiggy.png`, {
      frameWidth: 32,
      frameHeight: 32
    });
    this.load.spritesheet("TommyAvatar", `${externalHost}assets/tommy.png`, {
      frameWidth: 32,
      frameHeight: 32
    });
    this.load.spritesheet("J5Avatar", `${externalHost}assets/j5.png`, {
      frameWidth: 32,
      frameHeight: 32
    });
    this.load.spritesheet("npcChiefAvatar", `${externalHost}assets/npcChiefAvatar2.png`, {
        frameWidth: 388,
        frameHeight: 430
      });
    this.load.spritesheet("npcFarmerAvatar", `${externalHost}assets/npcFarmerAvatar.png`, {
        frameWidth: 388,
        frameHeight: 430
      });
    this.load.spritesheet("npcKnightAvatar", `${externalHost}assets/npcKnightAvatar.png`, {
        frameWidth: 388,
        frameHeight: 430
      });
  }




}